{
  "namespaceUris": [
    "http://opcfoundation.org/UA/",
    "http://opcfoundation.org/UA/MachineTool/",
    "http://opcfoundation.org/UA/Machinery/",
    "http://opcfoundation.org/UA/DI/",
    "http://opcfoundation.org/UA/IA/"
  ],
  "header": {
    "nameVariable": {
      "variablePath": "3:Identification.3:ProductInstanceUri",
      "dataType": "String"
    },
    "modelVariable": {
      "variablePath": "3:Identification.3:Model",
      "dataType": "LocalizedText"
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "id": "a095125dd5f0f09615c88d28501aca28",
      "title": "Identification",
      "rows": [
        {
          "id": "aa81bb687d91d66362f420beee140693",
          "elements": [
            {
              "id": "e053cabd9cedd5355d4998de961abdd2",
              "type": 0,
              "label": "Manufacturer",
              "valueVariable": {
                "variablePath": "3:Identification.3:Manufacturer",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "c8426a68a529932b30d76b765f383448",
              "type": 0,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductInstanceUri",
                "dataType": "String"
              }
            },
            {
              "id": "390ac0b6f2d697b6cdcae653d7bc7867",
              "type": 0,
              "label": "Serial Number",
              "valueVariable": {
                "variablePath": "3:Identification.3:SerialNumber",
                "dataType": "String"
              }
            },
            {
              "id": "f9f8001cbc0e51437447aae03a6d1317",
              "type": 0,
              "label": "Software Version",
              "valueVariable": {
                "variablePath": "3:Identification.3:SoftwareRevision",
                "dataType": "String"
              }
            },
            {
              "id": "5a3ac8b25c75972ebb886e3a88ee897e",
              "type": 0,
              "label": "Build Year",
              "valueVariable": {
                "variablePath": "3:Identification.3:YearOfConstruction",
                "dataType": "UInt16"
              }
            },
            {
              "id": "bb3c4e3e4b711214e29b2d89b92dbb45",
              "type": 0,
              "label": "Device Class",
              "valueVariable": {
                "variablePath": "3:Identification.3:DeviceClass",
                "dataType": "String"
              }
            },
            {
              "id": "caa7c510f43fe62277ff0d6d56eb5620",
              "type": 0,
              "label": "Location",
              "valueVariable": {
                "variablePath": "3:Identification.3:Location",
                "dataType": "String"
              }
            },
            {
              "id": "92fcfc1973029f3a8bb507891f3791b0",
              "type": 0,
              "label": "Model",
              "valueVariable": {
                "variablePath": "3:Identification.3:Model",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "59d343a5e30e62f78f301ebdc86b91c8",
              "type": 0,
              "label": "Product Code",
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductCode",
                "dataType": "String"
              }
            }
          ]
        }
      ]
    }
  ]
}
